(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusReviewControllers')
        .directive('actionPlanCriteriaReview', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                criteriaAssessment: '=',
                actionPlanUpdateStatusAssessment: '='
            },
            restrict: 'AE',
            templateUrl: require('./criteriaReview.tpl.html'),
            controller: ['$scope', '$state', '$stateParams', '$timeout', 'recomActionPlanUpdateStatusService', 'grcActionPlanCriteriaService', 'pageDirtyService', 'followUpService',
              function ($scope, $state, $stateParams, $timeout, recomActionPlanUpdateStatusService, grcActionPlanCriteriaService, pageDirtyService, followUpService) {

                  // Select Status
                  $scope.selectStatus = function (status) {
                      if ($scope.ctxtCtrl.isReadOnly) return;

                      $scope.criteriaAssessment.ReviewCompletionStatus = status;
                      $scope.criteriaAssessment.ReviewCompletionStatusID = status.LookupAttributeValueID;

                      if (isInProgress()) {
                          $scope.ctxtCtrl.isInProgress = true;
                      } else if (isCompleted()) {
                          $scope.ctxtCtrl.isCompleted = true;
                      }

                      if (_.isUndefined($scope.criteriaAssessment.ReviewTargetDate)) {
                          $scope.criteriaAssessment.ReviewTargetDate = $scope.criteriaAssessment.ActionPlanCriteria.TargetDate;
                      }

                      if (isFieldRequired('ReviewCompletionDate') && _.isUndefined($scope.criteriaAssessment.ReviewCompletionDate)) {
                          $scope.criteriaAssessment.ReviewCompletionDate = $scope.criteriaAssessment.ActionPlanCriteria.TargetDate;
                      }

                      $scope.setDirty();
                  };

                  // Review Criteria
                  $scope.reviewCriteria = function () {
                      $scope.ctxtCtrl.isReviewed = true;

                      // Form Invalid
                      if (!$scope.ctxtCtrl.isFormValid) {
                          $scope.ctxtCtrl.isFormInvalidError = true;
                          $timeout(function () {
                              $scope.ctxtCtrl.isFormInvalidError = false;
                          }, 3000);

                          // Require Follow-ups
                          if (areFollowUpsRequired()) {
                              $scope.ctxtCtrl.showRequireFollowUpError = true;
                              $timeout(function () {
                                  $scope.ctxtCtrl.showRequireFollowUpError = false;
                              }, 12500);
                          }

                          return;
                      }

                      $scope.ctxtCtrl.isLoading = true;
                      var requestDone = false,
                          timeoutDone = false;
                      $timeout(function () {
                          if (requestDone) {
                              $scope.ctxtCtrl.isLoading = false;
                          } else {
                              timeoutDone = true;
                          }
                      }, 250);

                      recomActionPlanUpdateStatusService
                          .reviewActionPlanCriteriaAssessment(
                              $scope.actionPlanUpdateStatusAssessment.ActionPlan.RecomBusinessUnitID,
                              $scope.actionPlanUpdateStatusAssessment.ActionPlan.ActionPlanID,
                              $scope.criteriaAssessment.ActionPlanCriteriaID,
                              $scope.criteriaAssessment)
                          .then(function (criteriaAssessment) {
                              $scope.criteriaAssessment = criteriaAssessment;
                              $scope.ctxtCtrl.isShowSubmitted = $scope.criteriaAssessment.IsReviewed;

                              if ($scope.criteriaAssessment.ReviewTargetDate) {
                                  $scope.criteriaAssessment.ReviewTargetDate =
                                      moment($scope.criteriaAssessment.ReviewTargetDate).format();
                              }

                              return recomActionPlanUpdateStatusService
                                  .getAssessmentsToReviewByAssessorAndActionPlan($scope.actionPlanUpdateStatusAssessment.ActionPlan.RecomBusinessUnitID,
                                                                                 $stateParams.ItemPersonID,
                                                                                 $stateParams.ActionPlanID)
                                  .then(function (assmntByInitiative) {

                                      $scope.actionPlanUpdateStatusAssessment.ActionPlanAssessment = assmntByInitiative.ActionPlanAssessment;

                                      pageDirtyService.setPageNotDirty();
                                      $scope.ctxtCtrl.isReviewModified = pageDirtyService.isPageDirty();

                                      if (timeoutDone) {
                                          $scope.ctxtCtrl.isLoading = false;
                                      } else {
                                          requestDone = true;
                                      }
                                  });
                          });
                  };

                  // Reset Assessment
                  $scope.resetAssessment = function () {
                      if ($scope.ctxtCtrl.isReadOnly) return;

                      var skipMarkPageDirty = $scope.criteriaAssessment.IsReviewed === false;
                      if (skipMarkPageDirty) {
                          pageDirtyService.setPageNotDirty();
                          $scope.ctxtCtrl.isReviewModified = pageDirtyService.isPageDirty();
                      }

                      // TODO: Use back-end solution to properly reset data
                      $scope.criteriaAssessment.IsReviewed = false;
                      $scope.criteriaAssessment.ReviewComment = null;
                      $scope.criteriaAssessment.ReviewCompletionDate = null;
                      $scope.criteriaAssessment.ReviewCompletionPercentage = 0;
                      $scope.criteriaAssessment.ReviewCompletionStatusID = null;
                      $scope.criteriaAssessment.ReviewCompletionStatus = null;
                      $scope.criteriaAssessment.ReviewTargetDate = null;
                      $scope.actionPlanUpdateStatusAssessment.ActionPlanAssessment.AreAllDeliverablesReviewed = false;
                      $scope.init();
                      $scope.setDirty(skipMarkPageDirty);
                  };

                  // Edit Assessment
                  $scope.editAssessment = function () {
                      $scope.ctxtCtrl.isShowSubmitted = false;
                      $scope.setDirty();
                  };

                  // Set Dirty
                  $scope.setDirty = function (skipMarkPageDirty) {
                      if ($scope.criteriaAssessment.ReviewCompletionStatusID) {
                          // Check if there are required fields and if they are provided
                          $scope.ctxtCtrl.isFormValid = areAllFieldsValid();
                      } else {
                          $scope.ctxtCtrl.isShowActions = false;
                      }
                      if (!$scope.ctxtCtrl.isReviewModified && !(_.isBoolean(skipMarkPageDirty) && skipMarkPageDirty)) {
                          pageDirtyService.setPageDirty('Reviews with yellow outline have unsaved changes. Please submit each of them or refresh the page (losing unsaved changes) to continue.');
                          $scope.ctxtCtrl.isReviewModified = pageDirtyService.isPageDirty();
                      }
                  };

                  // Completion Percentage Changed
                  $scope.completionPercentageChanged = function () {
                      if ($scope.ctxtCtrl.completionPercentage > 0) {
                          $scope.ctxtCtrl.isCompletionPercentageValid = true;
                          $scope.criteriaAssessment.ReviewCompletionPercentage = $scope.ctxtCtrl.completionPercentage;
                      } else {
                          $scope.ctxtCtrl.isCompletionPercentageValid = false;
                          $scope.criteriaAssessment.ReviewCompletionPercentage = null;
                      }
                      $scope.setDirty();
                  };

                  // Refresh Deliverable Review
                  $scope.refreshDeliverableReview = function () {
                      init();
                  };

                  // Get Plan Lookups
                  $scope.getPlanLookups = function () {
                      recomActionPlanUpdateStatusService
                          .getActionPlanUpdateStatusLookups()
                          .then(function (planLookups) {
                              $scope.planLookups = planLookups;
                          });
                  };

                  // Init
                  $scope.init = function () {

                      grcActionPlanCriteriaService
                         .getFollowUpListByActionPlanCriteria(
                             $scope.criteriaAssessment.ActionPlanID,
                             $scope.criteriaAssessment.ActionPlanCriteriaID)
                         .then(function (criteriaAssContainers) {
                             $scope.criteriaAssContainers = criteriaAssContainers;

                             if (_.size(criteriaAssContainers) > 0) {
                                 $scope.currentFollowUps = criteriaAssContainers[0].FollowUps;
                             }

                             $scope.setDirty(true);
                         });

                      if (!$scope.criteriaAssessment.ReviewCompletionPercentage) {
                          $scope.criteriaAssessment.ReviewCompletionPercentage =
                              $scope.criteriaAssessment.ActionPlanCriteria.CompletionPercentage;
                      }

                      $scope.ctxtCtrl = {
                          isReadOnly: false,
                          isCompleted: isCompleted(),
                          isInProgress: isInProgress(),
                          showDatePicker: false,
                          isLoading: false,
                          isShowActions: false,
                          isFormValid: areAllFieldsValid(),
                          completionPercentage: $scope.criteriaAssessment.ReviewCompletionPercentage,
                          isCompletionPercentageValid: $scope.criteriaAssessment.ReviewCompletionPercentage > 0,
                          isReviewed: false,
                          isFormInvalidError: false,
                          isShowSubmitted: $scope.criteriaAssessment.IsReviewed,
                          isReviewModified: false
                      };

                      $scope.criteriaAssessment.ActionPlanCriteria.TargetDate =
                          moment($scope.criteriaAssessment.ActionPlanCriteria.TargetDate).format();

                      if ($scope.criteriaAssessment.AssessmentTargetDate) {
                          $scope.criteriaAssessment.AssessmentTargetDate =
                              moment($scope.criteriaAssessment.AssessmentTargetDate).format();
                      }

                      if ($scope.criteriaAssessment.ReviewTargetDate) {
                          $scope.criteriaAssessment.ReviewTargetDate =
                              moment($scope.criteriaAssessment.ReviewTargetDate).format();
                      }

                      $scope.ctxtCtrl.isReadOnly = $scope.criteriaAssessment.IsReadOnly || !$scope.actionPlanUpdateStatusAssessment.ActionPlanAssessment.IsLocked;
                  };

                  // Download Attachments withing followup modals
                  $scope.getDownloadAttachmentUrl = function (attachmentId, criteriaAssessment) {
                      criteriaAssessment = criteriaAssessment || $scope.criteriaAssessment;

                      return recomActionPlanUpdateStatusService
                          .getDownloadAttachmentUrl(
                              criteriaAssessment.ActionPlanCriteria.RecomBusinessUnitID,
                              criteriaAssessment.ActionPlanID,
                              criteriaAssessment.ActionPlanCriteriaID,
                              criteriaAssessment.ActionPlanCriteriaAssessmentID,
                              attachmentId);
                  };

                  // View FollowUps
                  $scope.viewFollowUps = function () {
                      var modalScope = followUpService.openFollowUpsModal(null,
                                                                          $scope.criteriaAssessment,
                                                                          $scope.currentFollowUps,
                                                                          $scope.criteriaAssContainers,
                                                                          $scope.getDownloadAttachmentUrl);

                      modalScope.submitFollowUp = function (followUp) {
                          return recomActionPlanUpdateStatusService
                                  .createActionPlanCriteriaReviewFollowUp(
                                      $scope.actionPlanUpdateStatusAssessment.ActionPlan.RecomBusinessUnitID,
                                      $scope.criteriaAssessment.ActionPlanID,
                                      $scope.criteriaAssessment.ActionPlanCriteriaID,
                                      $scope.criteriaAssessment.ActionPlanCriteriaAssessmentID,
                                      followUp)
                                  .then(function (assessmentContainer) {
                                      var newFollowUp = assessmentContainer.FollowUps[0];
                                      modalScope.currentFollowUps.unshift(newFollowUp);
                                      $scope.currentFollowUps = modalScope.currentFollowUps;
                                      $scope.setDirty(true);
                                  });
                      };
                  };

                  // Is Status Completed
                  $scope.isStatusCompleted = isCompleted;

                  // Are FollowUps Required
                  function areFollowUpsRequired() {
                      if ($scope.criteriaAssessment.ReviewCompletionStatusID === 161) return false; // NoIssue
                      if ($scope.criteriaAssessment.ReviewCompletionStatusID === 164) return false; // NotStarted
                       
                      var areFollowUpsByReviewerPresent =
                              _.chain($scope.currentFollowUps)
                               .filter({ UserIsReviewer: true })
                               .some(function (followUp) {
                                   if (followUp.Comment) return true;

                                   return _.size(followUp.Attachments) > 0;
                               })
                               .value();

                      return !areFollowUpsByReviewerPresent;
                  }

                  function areAllFieldsValid() {
                      if (!$scope.criteriaAssessment.ReviewCompletionStatusID) return false;

                      var conditions = $scope.criteriaAssessment.ReviewFieldConditions_ByCompletionStatusID,
                          statusID = $scope.criteriaAssessment.ReviewCompletionStatusID;
                      for (var attribute in conditions[statusID]) {
                          if (conditions[statusID].hasOwnProperty(attribute)
                              && conditions[statusID][attribute].required
                              && conditions[statusID][attribute].required === 'true'
                              && !$scope.criteriaAssessment[attribute]) {
                              return false;
                          }
                      }

                      return true; //!areFollowUpsRequired();
                  }

                  // Is Field Required?
                  function isFieldRequired(fieldName) {
                      if (_.isUndefined(fieldName)) return false;
                      if (_.isUndefined($scope.criteriaAssessment.ReviewFieldConditions_ByCompletionStatusID)) return false;

                      var conditionsByCompStatusID = $scope.criteriaAssessment.ReviewFieldConditions_ByCompletionStatusID;
                      var compStatusID = $scope.criteriaAssessment.ReviewCompletionStatusID;
                      var fieldConditions = conditionsByCompStatusID[compStatusID][fieldName];

                      if (_.isUndefined(fieldConditions)) return false;

                      return fieldConditions['required'];
                  }

                  function isCompleted() {
                      return $scope.criteriaAssessment.ReviewCompletionStatusID === 160;
                  }

                  function isInProgress() {
                      if (!$scope.criteriaAssessment.ReviewCompletionStatus) return false;

                      return $scope.criteriaAssessment.ReviewCompletionStatus.Value === 'No-Issue'
                          || $scope.criteriaAssessment.ReviewCompletionStatus.Value === 'Issues-Being-Monitored'
                          || $scope.criteriaAssessment.ReviewCompletionStatus.Value === 'Issues-To-Address';
                  }
            }],
            link: function (scope, element, attrs) {
                scope.init();
                scope.getPlanLookups();
            }
        };
    }
})();